export const TASKS_STATUS = {
    ASSIGNED: 0,
    STARTED: 1,
    SUCCESSFUL: 2,
    FAILED: 3,
    INPROGRESS: 4,
    UNASSIGNED: 6,
    ACCEPTED: 7,
    DECLINED: 8,
    CANCEL: 9,
}

export const WAREHOUSE_STATUS = {
    RECEIVED: 1,
    DISPATCHED: 2
}

export const VIEW_TYPE = {
    MAP: 1,
    RATING: 2,
    NOT_FOUND: 3
}

export const TASK_TYPE = {
  PICKUP: 0,
  DELIVERY: 1
}